import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { changeDateFormat } from "../../../utils";
import "./PreUploadFileListTable.scss";

const PreUploadFileListTable = ({ fileList, onDelete }) => {
  const fileNameTemplate = (rowData) => {
    return (
      <span 
        title={rowData.File_Name}
        className="file-name-cell"
      >
        {rowData.File_Name}
      </span>
    );
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
  };

  const fileSizeTemplate = (rowData) => {
    const size = formatFileSize(rowData.fileSize);
    return (
      <span title={size}>
        {size}
      </span>
    );
  };

  const ownerTemplate = (rowData) => {
    const ownerInfo = `${rowData.Full_Name} - ${rowData.Email}`;
    return (
      <div title={ownerInfo}>
        {rowData.Full_Name}
        <br />
        {rowData.Email}
      </div>
    );
  };

  const dateTemplate = (rowData) => {
    const formattedDate = changeDateFormat(rowData.Timestamp);
    return (
      <span title={formattedDate}>
        {formattedDate}
      </span>
    );
  };

  const deleteTemplate = (rowData, rowOptions) => {
    return (
      <Button
        icon="pi pi-times"
        severity="danger"
        rounded
        text
        onClick={() => onDelete(rowOptions.rowIndex)}
        title="Remove file"
      />
    );
  };

  if (fileList.length === 0) {
    return null;
  }

  return (
    <div className="pre-upload-file-list-table-container">
      <h4>Selected Files ({fileList.length})</h4>
      <DataTable value={fileList} className="pre-upload-file-list-table" scrollable scrollHeight="300px">
        <Column
          field="File_Name"
          header="File Name"
          headerClassName="pre-upload-file-list-header"
          bodyClassName="pre-upload-file-list-data-row"
          body={fileNameTemplate}
        />
        <Column
          field="fileSize"
          header="File Size"
          headerClassName="pre-upload-file-list-header"
          bodyClassName="pre-upload-file-list-data-row text-center"
          body={fileSizeTemplate}
          alignHeader="center"
        />
        <Column
          header="Owner"
          headerClassName="pre-upload-file-list-header"
          bodyClassName="pre-upload-file-list-data-row text-center"
          body={ownerTemplate}
          alignHeader="center"
        />
        <Column
          field="Timestamp"
          header="Date"
          headerClassName="pre-upload-file-list-header"
          bodyClassName="pre-upload-file-list-data-row text-center"
          body={dateTemplate}
          alignHeader="center"
        />
        <Column
          header="Remove"
          headerClassName="pre-upload-file-list-header"
          bodyClassName="pre-upload-file-list-data-row text-center"
          body={deleteTemplate}
          alignHeader="center"
        />
      </DataTable>
    </div>
  );
};

export default PreUploadFileListTable;
